import get from 'lodash/get'
import { FIELD_TEXT_MAP } from '../constant'
// 控制字段展示顺序
export const CLUE_INFORMATION = [
  'id',
  'city',
  'name',
  'channelTypeName',
  'channelName',
  'gmtCreate',
  'state',
  'storeName',
  'label',
]

const INTENDED_COMMODITY_FIELD = [
  'goodsId',
  'goodsName',
  'carBrand',
  'carSeries',
  'planName',
  'rentAmount',
  'rentCycle',
  'depositAmount',
]
const ASSOCIATED_ORDER_FIELD = [
  'orderId',
  'plateNo',
  'brandName',
  'seriesName',
  'carModel',
  'orderState',
  'rentCategory',
  'orderCreateTime',
]
const FOLLOW_UP_RECORDS_FIELD = [
  'followTime',
  'clueState',
  'followRemarks',
  'nextFollowTime',
  'followUser',
]
export const fieldRenderTypeMap = new Map([
  ['label', 'tag'], // 线索标签
  ['name', 'edit'], // 姓名
  ['goodsId', 'goodsId'], // 商品ID
  ['orderId', 'orderId'], // 订单ID
])

export const getLeadTagConfig = (data) => {
  return {
    name: FIELD_TEXT_MAP.get('label'),
    tags: data.label,
  }
}

const getColumnBoxSource = (items, data = {}) => {
  const source = {}
  if (!Array.isArray(items)) {
    return source
  }
  items.forEach((field) => {
    source[field] = data[field]
  })
  return source
}

export const getGroupInfo = (data) => {
  return [
    {
      groupRenderType: 'row-col',
      title: '线索信息',
      items: CLUE_INFORMATION.map((field) => {
        const name = FIELD_TEXT_MAP.get(field)
        let renderType = fieldRenderTypeMap.get(field)
        if (field === 'name') {
          // 集团不展示 edit
          renderType = 'name'
        }
        return {
          key: renderType || field,
          name,
          value: data[field],
          field,
          alone: field === 'label',
        }
      }),
      source: getColumnBoxSource(CLUE_INFORMATION, data),
      platformTag: data.platformTag,
    },
    {
      groupRenderType: 'row-col',
      title: '意向商品',
      items: INTENDED_COMMODITY_FIELD.map((field) => {
        const name = FIELD_TEXT_MAP.get(field)
        return {
          name,
          key: field,
          value: data[field] || get(data, `goods.${field}`),
          field,
        }
      }),
      source: getColumnBoxSource(INTENDED_COMMODITY_FIELD, get(data, 'goods') || {}),
    },
    {
      groupRenderType: 'row-col',
      title: '关联订单',
      items: ASSOCIATED_ORDER_FIELD.map((field) => {
        const name = FIELD_TEXT_MAP.get(field)
        return {
          name,
          key: field,
          value: data[field],
          field,
        }
      }),
      source: getColumnBoxSource(ASSOCIATED_ORDER_FIELD, data),
    },
    {
      groupRenderType: 'table',
      title: '跟进记录',
      list: data.clueFollowList || [],
      columns: FOLLOW_UP_RECORDS_FIELD.map((field) => {
        const label = FIELD_TEXT_MAP.get(field)
        const commonProps = {
          name: field,
          columnProps: {
            label,
            prop: field,
          },
        }
        let otherProps = {}
        switch (field) {
          case 'followTime':
          case 'nextFollowTime':
            commonProps.columnProps.width = 180
            break
          case 'clueState':
            commonProps.columnProps.width = 100
            break
          case 'followRemarks':
            otherProps = {
              type: 'manual',
            }
            commonProps.columnProps.width = 240
            delete commonProps.columnProps.prop
            break
          default:
            break
        }
        return Object.assign(commonProps, otherProps)
      }),
    },
  ]
}
